"use strict";

var jbh = {};

(function() {

	/***************************************
		Common methods
	***************************************/

	var isTouchDevice = function() { return 'ontouchstart' in window || navigator.maxTouchPoints; }
	var vpWidth = function() { return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); }
	var vpHeight = function() { return Math.max(document.documentElement.clientHeight, window.innerHeight || 0); }
	var getScrollingElement = function() { return document.scrollingElement ? document.scrollingElement : document.documentElement; }
	var getScrollPos = function() { return getScrollingElement().scrollTop || window.pageYOffset; }
	var isIE = function() { return document.body.classList.contains('is-ie'); };
	var isSafari = function() { return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') == -1; }

	function debounce(func, delay) {
		var wait;

		delay = delay || 50;
		return (function() {
			var context = this,
				args = arguments;

			clearTimeout(wait);
			wait = setTimeout(function() {
				func.apply(context, args);
			}, delay);
		})();
	}

	function xhrCors(method, url, async) {
		var xhr = new XMLHttpRequest();
		async = async || false;

		if ("withCredentials" in xhr) {
			xhr.open(method, url, async);
		} else if (typeof XDomainRequest != "undefined") {
				xhr = new XDomainRequest();
			xhr.open(method, url);
		} else {
			xhr = null;
		}

		return xhr;
	}




	/***************************************
		Main Events
	***************************************/

	var imgPreloader, vidPreloader, resizer;

	var init = function() {
		var main          = document.querySelector('.main');
		imgPreloader      = new ImagePreloader(main);
		vidPreloader      = new VideoPreloader(main, { prefetchVideos: true });
		resizer           = resizeBody();

		toggleMenu();
		switchCaptchas();
		productSlider();
		cart();
		credits();

		jbh = {
			imgPreloader,
			vidPreloader,
			resizer
		};
	}


	var resizeBody = function() {
		var changeHeight = function() {
			var root   = document.documentElement,
				header = document.querySelector('.header-inner'),
				footer = document.querySelector('.footer'),
				height = window.innerHeight,
				width  = vpWidth(),
				vw     = 0.01 * document.body.clientWidth,
				vh     = 0.01 * window.innerHeight;

			root.style.setProperty('--vw', vw + 'px');
			root.style.setProperty('--vh', vh + 'px');

			if (header) {
				let style   = getComputedStyle(header),
					hTop    = parseInt(style.top),
					border  = parseInt(style.borderTopWidth + style.borderBottomWidth),
					hHeight = header.getBoundingClientRect().height;

				root.style.setProperty('--headerHeight', hTop + border + hHeight + 'px');
			}

			if (footer) {
				let style   = getComputedStyle(footer),
					border  = parseInt(style.borderTopWidth + style.borderBottomWidth),
					hHeight = footer.getBoundingClientRect().height;

				root.style.setProperty('--footerHeight', border + hHeight + 'px');
			}

			document.body.style.height = window.innerHeight + 'px';
		}

		setTimeout(changeHeight, 20);

		window.addEventListener('resize', changeHeight);
		window.addEventListener('orientationchange', changeHeight);

		if ('screen' in window && 'orientation' in screen)
			screen.orientation.addEventListener('change', changeHeight);

		return changeHeight;
	}





	/**************************************************
		Lazy Loading
	**************************************************/

	class ImagePreloader {
		constructor(wrapper) {
			this.wrapper  = wrapper || document;
			this.images   = [];

			this.options  = { };
			this.observer = new IntersectionObserver(this.intersectionsFound.bind(this), this.options);

			this.findImages(wrapper)
			this.prepareImages();
			this.checkVisibility();
			this.registerEvents();
		}

		findImages(wrapper) {
			wrapper || document;
			let newImages = [].slice.call(wrapper.querySelectorAll('img.lazy'));

			this.images = this.images.concat(newImages);
			this.prepareImages(newImages);
		}

		prepareImages() {
			this.images.forEach(image => {
				if (image.nextElementSibling && image.nextElementSibling.tagName === 'NOSCRIPT')
					image.parentElement.removeChild(image.nextElementSibling);

				var parentWidth   = image.parentElement.scrollWidth,
					naturalWidth  = image.getAttribute('width'),
					naturalHeight = image.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				image.style.height = newHeight  + 'px';

				this.observer.observe(image);
			});
		}

		intersectionsFound(entries) {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;
				this.loadImage(entry.target);
			});
		}

		checkVisibility() {
			if (this.images.length == 0) return;

			debounce((function() {				
				var winWidth = vpWidth(),
					winHeight = vpHeight();

				this.images.forEach(image => {
					var clientRect = image.getBoundingClientRect();					

					if (clientRect.top + clientRect.height >= 0 &&
						clientRect.top < winHeight &&
						clientRect.left + clientRect.width >= 0 &&
						clientRect.left < winWidth) {

						this.loadImage(image);
					}
				});
			}).bind(this));
		};

		loadImage(image) {
			if (!image || !image.classList.contains('lazy')) return;

			image.src    = image.dataset.src;
			image.srcset = image.dataset.srcset;
			image.classList.add('loaded');
			image.style.height = '';

			this.observer.unobserve(image);
			this.images = this.images.filter(img => img !== image);

			setTimeout(function() {
				image.classList.remove('lazy', 'loaded');
				image.removeAttribute('data-src');
				image.removeAttribute('data-srcset');
			}, 1000);
		}

		loadImagesNow(wrapper) {
			wrapper = wrapper || document;

			var imgs = wrapper.querySelectorAll('img.lazy');
			[].forEach.call(imgs, (function(img) {
				this.loadImage(img);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('resize', (function() { this.checkVisibility(); }).bind(this), false);
		}
	}




	class VideoPreloader {
		constructor(wrapper, args = {}) {
			this.wrapper = wrapper || document;
			
			this.defaults = {
				mobileThreshold:	20,
				prefetchVideos:		false
			}

			this.args = Object.assign(this.defaults, args);
			this.videos = [];

			this.options  = { };
			this.observer = new IntersectionObserver(this.intersectionsFound.bind(this), this.options);

			this.findVideos();
			this.checkVisibility();
			this.registerEvents();
		}

		findVideos() {
			this.videos = this.videos.concat([].slice.call(this.wrapper.querySelectorAll('video.lazy')));

			this.videos.forEach(video => {
				var parentWidth   = video.parentElement.scrollWidth,
					naturalWidth  = video.getAttribute('width'),
					naturalHeight = video.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				video.style.height = newHeight  + 'px';
				video.addEventListener('loadedmetadata', () => video.classList.remove('is-loading'));

				this.observer.observe(video);

				if (this.args.prefetchVideos)
					this.addVideoToPrefetch(video);				
			});
		}

		intersectionsFound(entries) {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;
				this.loadVideo(entry.target);
			});
		}


		checkVisibility() {
			if (this.videos.length == 0) return;

			debounce((function() {				
				var winWidth = vpWidth(),
					winHeight = vpHeight();

				this.videos.forEach(video => {
					var clientRect = video.getBoundingClientRect();

					if (clientRect.top + clientRect.height <= 0) return true;
					if (clientRect.top >= winHeight) return true;
					if (clientRect.left + clientRect.width <= 0) return true;
					if (clientRect.left >= winWidth) return true;

					let elem    = video,
						visible = true;

					while (elem && visible == true) {
						let opacity = getComputedStyle(elem).getPropertyValue('opacity');
						visible = visible && (opacity == '' || parseFloat(opacity) !== 0);
						visible = visible && elem.style.display !== 'none';
						visible = visible && elem.style.visibility !== 'hidden';

						elem = elem.parentElement || null;
					}

					if (visible == false) return;

					this.loadVideo(video);
				});
			}).bind(this));
		}


		addVideoToPrefetch(video) {
			let sources = this.getSources(video);
			if (sources.length == 0) return;

			let head = document.querySelector('head'),
				tag  = document.createElement('link');

			tag.setAttribute('rel', 'prefetch');
			tag.setAttribute('href', sources[0].source);
			head.appendChild(tag);
		}


		loadVideo(elem) {
			if (!elem || elem.loading === true || !elem.classList.contains('lazy')) return;

			elem.loading = true;
			elem.classList.add('is-loading');

			if (this.args.mobileThreshold > vpWidth()) {
				elem.setAttribute('preload', 'metadata');
			}

			elem.innerHTML = this.getSourcesTags(elem).join('');
			elem.classList.remove('lazy');
			elem.removeAttribute('data-sources');

			if (!elem.closest('.no-autoplay'))
				elem.autoplay = true;
			elem.style.height = '';

			this.observer.unobserve(elem);
			this.videos = this.videos.filter(video => video !== elem);
		}

		getSources(elem) {
			var files   = JSON.parse(elem.dataset.sources),
				width   = elem.parentElement.getBoundingClientRect().width,
				mimes   = {},
				sources = [];

			for (let file in files) {
				let mime = files[file].mime;
				if (!mimes.hasOwnProperty(mime)) mimes[mime] = {};
				mimes[mime][file] = files[file];
			}

			for (var mime in mimes) {
				if (!mimes.hasOwnProperty(mime)) continue;

				var versions = mimes[mime];

				Object.entries(versions).forEach(([key, info], i) => {
					let media       = '',
						isLandscape = info.width >= info.height;

					sources.push({
						source: 		info.file,
						mime:   		mime,
						media:  		info.size,
						isLandscape:	isLandscape
					});
				});
			}

			return sources;
		}

		getSourcesTags(elem) {
			let sources = this.getSources(elem);
			return sources.map(s => '<source src="' + s.source + '" type="' + s.mime + '" media="' + s.media + '">')
		}

		loadVideosNow(wrapper) {
			wrapper = wrapper || document;

			var videos = wrapper.querySelectorAll('video.lazy');
			[].forEach.call(videos, (function(video) {
				this.loadVideo(video);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('resize', this.checkVisibility.bind(this), false);
		}
	}






	/***************************************
		Toggle Menu
	***************************************/

	var toggleMenu = function() {
		var	menu   = document.querySelector('.header-menu');
		if (!menu) return;

		let toggle = menu.querySelector('.header-menu-toggle'),
			inner  = menu.querySelector('.header-menu-inner');

		var toggleMenuVisibility = function() {
			menu.classList.toggle('show-menu');
			updateSize();
		};

		var updateSize = function() {
			inner.style.maxHeight = menu.classList.contains('show-menu') ? inner.scrollHeight + 'px' : 0;
		}

		toggle.addEventListener('click', toggleMenuVisibility);
		document.addEventListener('resize', updateSize);
	}







	/***************************************
		Switch captchas
	***************************************/

	var switchCaptchas = function() {
		let captchas = [].slice.call(document.querySelectorAll('.header-logo img'));
		if (captchas.length < 2) return;

		let switchDistance   = 1 / 3,
			onLoadIterations = 20,
			onLoadTotalDelay = 2000;


		let switchOnLoad = function() {
			let targetIndex = getTargetCaptcha(),
				startIndex  = targetIndex - onLoadIterations;

			for (let i = 1; i < onLoadIterations; i++) {
				let iterationIndex = startIndex - onLoadIterations + i,
					progress       = getDelayEase(i / onLoadIterations),
					delay          = progress * onLoadTotalDelay;

				if (i == onLoadIterations - 1)
					iterationIndex = targetIndex;

				while (iterationIndex < 0) {
					iterationIndex += captchas.length;
				}

				setTimeout(() => switchToCaptcha(iterationIndex), delay);
			}
		};


		let getDelayEase = function(t) {
			return t * t * t;
		}


		let update = function() {
			switchToCaptcha(getTargetCaptcha());
		};


		let switchToCaptcha = function(index) {
			captchas.forEach((captcha, i) => captcha.classList.toggle('active', i == index));
		};


		let getTargetCaptcha = function() {
			let docHeight      = Math.max(1, Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - vpHeight()),
				amountSections = Math.max(1, Math.ceil(docHeight / (switchDistance * vpHeight())));

			return Math.floor(getScrollPos() / (docHeight / amountSections)) % captchas.length;
		};

		switchOnLoad();
		document.addEventListener('resize', update);
		window.addEventListener('scroll', update);
	};







	/***************************************
		Product slider
	***************************************/

	var productSlider = function() {
		let elem = document.querySelector('.single-product-images.slider');
		if (!elem) return;

		let images = [].slice.call(elem.querySelectorAll('.product-image'));

		let switchTo = function(e) {
			let target = e.target.classList.contains('.product-image') ? e.target : e.target.closest('.product-image');
			console.log(images, target);
			images.forEach(image => image.classList.toggle('active', image == target));
		};

		images.forEach(image => image.addEventListener('click', switchTo));
	};







	/***************************************
		Cart
	***************************************/

	var cart = function() {
		var elem = document.querySelector('.page-cart');
		if (!elem) return;

		let items     = [].slice.call(elem.querySelectorAll('.cart-item')),
			errorElem = elem.querySelector('.cart-error-message'),
			subtotal  = elem.querySelector('.subtotal');

		let updateCartQuantity = async function(e) {
			let target   = e.target,
				line     = target.closest('.cart-item').dataset.line,
				quantity = target.value;

			try {
				const body     = JSON.stringify({ line: line, quantity: Number(quantity) });
				const response = await fetch('/cart/change.js', {
					method:		'POST',
					headers:	{
						'Content-Type':	'application/json',
						'Accept': 		'application/json'
					},
					body:		body
				});

				if (!response.ok) {
					reportError('Cart update failed.');
					console.error(`Cart update failed: ${response.status}`);
					return;
				}

				const cart = await response.json();

				cart.items.forEach((item, i) => {
					let price = items[i].querySelector('.cart-item-price');
					price.textContent = formatPrice(item.line_price, cart.currency);
				})

				subtotal.textContent = formatPrice(cart.items_subtotal_price, cart.currency);
			} catch (error) {
				reportError('Cart update failed.');
				console.error('Cart update failed:', error);
			}
		};


		let reportError = function(message) {
			errorElem.innerText = message;
			errorElem.classList.remove('hide');
		};


		let formatPrice = function(price, currency) {
			return new Intl.NumberFormat(undefined, {
				style:		'currency',
				currency:	currency
			}).format(price / 100);
		}


		items.forEach(item => {
			let select = item.querySelector('.cart-item-quantity-select');

			select.addEventListener('change', updateCartQuantity);
		});
	};





	/************************************************************
		Credits
	 ************************************************************/

	var credits = function() {
		var credits = '**********\n\nThis website was designed by Workout Services.\nhttps://www.workout-services.com/\n\nIt was built by Matthias Planitzer.\nwww.matthias-planitzer.de\n\n**********';
		console.log('%c' + credits, 'color: #00F; font-family: Helvetica Neue", Helvetica, sans-serif; font-size: 14px;');	
	}





	/***************************************
		Swipe detect
	***************************************/

	class SwipeDetect {
		constructor(elem, callback, args) {
			var defaults = {
				minDistance:       50,
				addMouseEvents:    true,
				addDragDropEvents: true,
				horizontal:        true,
				vertical:          true,
				stagger:           100
			};

			this.elem      = elem;
			this.callback  = callback;
			this.args      = Object.assign(defaults, args);

			this.active    = false;
			this.eventType = null;
			this.lastPos   = { x: null, y: null };
			this.lastEmit  = Date.now();
			
			this.registerEvents();
		}

		destruct() {
			this.elem.removeEventListener('touchstart', this.fn.startTouch, { passive: true });
			this.elem.removeEventListener('touchmove',  this.fn.move, { passive: true });
			this.elem.removeEventListener('touchend',   this.fn.end);

			if (this.args.addMouseEvents) {
				this.elem.removeEventListener('mousedown',  this.fn.startMouse);
				this.elem.removeEventListener('mousemove',  this.fn.move);
				this.elem.removeEventListener('mouseleave', this.fn.end);
				 document.removeEventListener('mouseup',    this.fn.end);
			}

			if (this.args.addDragDropEvents) {
				this.elem.removeEventListener('dragstart', this.fn.startDragDrop);
				this.elem.removeEventListener('dragleave', this.fn.end);
				this.elem.removeEventListener('dragexit',  this.fn.end);
				this.elem.removeEventListener('drop',      this.fn.end);
			}
		}

		registerEvents() {
			this.fn = {
				startDragDrop: this.startDragDrop.bind(this),
				startMouse:    this.startMouse.bind(this),
				startTouch:    this.startTouch.bind(this),
				move:          this.move.bind(this),
				end:           this.end.bind(this),
			};

			this.elem.addEventListener('touchstart', this.fn.startTouch, { passive: true });
			this.elem.addEventListener('touchmove',  this.fn.move, { passive: true });
			this.elem.addEventListener('touchend',   this.fn.end);

			if (this.args.addMouseEvents) {
				this.elem.addEventListener('mousedown',  this.fn.startMouse);
				this.elem.addEventListener('mousemove',  this.fn.move);
				this.elem.addEventListener('mouseleave', this.fn.end);
				 document.addEventListener('mouseup',    this.fn.end);
			}

			if (this.args.addDragDropEvents) {
				this.elem.addEventListener('dragstart', this.fn.startDragDrop);
				this.elem.addEventListener('dragleave', this.fn.end);
				this.elem.addEventListener('dragexit',  this.fn.end);
				this.elem.addEventListener('drop',      this.fn.end);
			}
		}

		startTouch(event) {
			this.active    = true;
			this.eventType = 'touch';
			this.lastPos   = this.getPosition(event);
		}

		startMouse(event) {
			this.active    = true;
			this.eventType = 'mouse';
			this.lastPos   = this.getPosition(event);
		}

		startDragDrop(event) {
			this.active    = true;
			this.eventType = 'dragdrop';
			this.lastPos   = this.getPosition(event);
		}

		move(event) {
			if (!this.active) return;

			var now         = Date.now(),
				timeElapsed = now - this.lastEmit;
			if (timeElapsed < this.args.stagger) return;

			var	newPos      = this.getPosition(event),
				distance    = this.distance(this.lastPos, newPos),
				result      = {
					distance2D:  Math.sqrt(distance.x * distance.x + distance.y * distance.y),
					direction2D: Math.atan2(distance.y, distance.x),
					type:        this.eventType,
					event: 		 event
				};

			if (this.args.horizontal) {
				result.distanceX  = distance.x;
				result.directionX = Math.abs(distance.x) > this.args.minDistance ? Math.sign(distance.x / this.args.minDistance) : 0;
			}

			if (this.args.vertical) {
				result.distanceY  = distance.y;
				result.directionY = Math.abs(distance.y) > this.args.minDistance ? Math.sign(distance.y / this.args.minDistance) : 0;
			}
			
			if ((result.directionX !== 0 && this.args.horizontal) ||
				(result.directionY !== 0 && this.args.vertical)) {
				this.lastPos  = newPos;
				this.lastEmit = now;

				this.callback(result);
			}
		}

		end(event) {
			this.active = false;
		}

		getPosition(event) {
			var pos = this.eventType == 'touch' ? event.touches[0] : event;
			return { x: pos.clientX, y: pos.clientY };
		}

		distance(pos1, pos2) {
			return { x: pos1.x - pos2.x, y: pos1.y - pos2.y };
		}
	}


	class WheelDetect {
		constructor(elem, args = {}) {
			let defaults = {
				callback:             (direction) => console.log('WheelDetect: ' + direction),
				delay:                150,
				deltaMultiplier:      40,
				flatteningFrameSize:  8,
				fluctuationTolerance: 1.1,
				minimumDelta:         100
			};

			this.elem           = elem || document;
			this.args           = Object.assign(defaults, args);
			this.lastDeltasUp   = this.setUpArray();
			this.lastDeltasDown = this.setUpArray();
			this.lastDeltasTime = this.setUpArray();

			this.wheelEvent 	= 'onwheel' in document
								? 'wheel'
								: ('onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll');

			this.elem.addEventListener(this.wheelEvent, this.wheelTriggered.bind(this), { passive: true });
		}

		setUpArray() {
			let arr = [];
			for (let i = 1, size = this.args.flatteningFrameSize * 2; 1 <= size ? i <= size : i >= size; 1 <= size ? i++ : i--) {
				arr.push(null);
			}

			return arr;
		}

		wheelTriggered(e) {
			e = e.originalEvent || e;

			let delta;

			if (e.wheelDelta !== null) {
				delta = e.wheelDelta;
			} else if (e.deltaY !== null) {
				delta = - e.deltaY * this.args.deltaMultiplier;
			} else if (e.detail !== null || e.detail === 0) {
				delta = - e.detail * this.args.deltaMultiplier;
			}

			this.lastDeltasTime.push(Date.now());
			this.lastDeltasTime.shift();

			if (delta > 0) {
				this.lastDeltasUp.push(delta);
				this.lastDeltasUp.shift();
				return this.isInertiaScroll('up');
			} else if (delta < 0) {
				this.lastDeltasDown.push(delta);
				this.lastDeltasDown.shift();
				return this.isInertiaScroll('down');
			}

			return this.args.callback(false);
		}

		isInertiaScroll(direction) {
			let deltas = direction === 'down' ? this.lastDeltasDown : this.lastDeltasUp;
			if (deltas[0] === null)
				return this.args.callback(direction);

			if (this.lastDeltasTime[(this.args.flatteningFrameSize * 2) - 2] + this.args.delay > Date.now() &&
				         deltas[(this.args.flatteningFrameSize * 2) - 1] === deltas[0])
				return this.args.callback(false);

			let lastDeltasOld = deltas.slice(0,                             this.args.flatteningFrameSize),
				lastDeltasNew = deltas.slice(this.args.flatteningFrameSize, this.args.flatteningFrameSize * 2),
				averageOld    = lastDeltasOld.reduce((acc, val) => acc + val) / lastDeltasOld.length,
				averageNew    = lastDeltasNew.reduce((acc, val) => acc + val) / lastDeltasNew.length;

			if (Math.abs(averageOld) < Math.abs(averageNew * this.args.fluctuationTolerance) &&
				Math.abs(averageNew) > this.args.minimumDelta)
				return this.args.callback(direction);
			
			return this.args.callback(false);
		}

		destroy() {
			this.elem.removeEventListener(this.wheelEvent, this.wheelTriggered.bind(this));
		}
	}






	init();
})();